import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { LatexRenderer } from '../../ui/LatexRenderer';
interface AnswerComparisonProps {
  userAnswer: string;
  correctAnswer: string;
  isCorrect: boolean;
  mode?: 'full' | 'compact';
}
/**
 * Displays user's answer compared to the correct answer.
 * Used in both PracticeSession (immediate feedback) and CitoSimulator (review).
 */
export function AnswerComparison({
  userAnswer,
  correctAnswer,
  isCorrect,
  mode = 'full'
}: AnswerComparisonProps) {
  if (mode === 'compact') {
    return <div className="grid gap-2" data-id="element-1189">
        <div className={`p-2.5 rounded-lg border ${isCorrect ? 'border-emerald-300 bg-emerald-50' : 'border-rose-200 bg-rose-50'}`} data-id="element-1190">
          <div className="text-xs font-bold uppercase mb-0.5 text-slate-500" data-id="element-1191">
            Jouw antwoord
          </div>
          <div className="font-medium text-slate-900 text-sm" data-id="element-1192">
            <LatexRenderer content={userAnswer} data-id="element-1193" />
          </div>
        </div>

        {!isCorrect && <div className="p-2.5 rounded-lg border border-emerald-200 bg-emerald-50" data-id="element-1194">
            <div className="text-xs font-bold uppercase mb-0.5 text-emerald-700" data-id="element-1195">
              Goede antwoord
            </div>
            <div className="font-medium text-emerald-900 text-sm" data-id="element-1196">
              <LatexRenderer content={correctAnswer} data-id="element-1197" />
            </div>
          </div>}
      </div>;
  }
  return <div className="flex flex-col md:flex-row gap-3" data-id="element-1198">
      {/* User's answer */}
      <motion.div initial={{
      opacity: 0,
      x: -10
    }} animate={{
      opacity: 1,
      x: 0
    }} className="flex-1" data-id="element-1199">
        <div className="bg-rose-50 rounded-xl p-3.5 border border-rose-200 h-full" data-id="element-1200">
          <div className="flex items-center gap-2 mb-1.5" data-id="element-1201">
            <div className="w-5 h-5 rounded-full bg-rose-200 flex items-center justify-center" data-id="element-1202">
              <X className="w-3 h-3 text-rose-700" strokeWidth={3} data-id="element-1203" />
            </div>
            <span className="text-xs font-bold uppercase tracking-wider text-rose-600" data-id="element-1204">
              Jouw antwoord
            </span>
          </div>
          <div className="font-bold text-rose-900 text-lg pl-7" data-id="element-1205">
            <LatexRenderer content={userAnswer} data-id="element-1206" />
          </div>
        </div>
      </motion.div>

      {/* Correct answer */}
      {!isCorrect && <motion.div initial={{
      opacity: 0,
      x: 10
    }} animate={{
      opacity: 1,
      x: 0
    }} className="flex-1" data-id="element-1207">
          <div className="bg-emerald-50 rounded-xl p-3.5 border border-emerald-200 h-full" data-id="element-1208">
            <div className="flex items-center gap-2 mb-1.5" data-id="element-1209">
              <div className="w-5 h-5 rounded-full bg-emerald-200 flex items-center justify-center" data-id="element-1210">
                <Check className="w-3 h-3 text-emerald-700" strokeWidth={3} data-id="element-1211" />
              </div>
              <span className="text-xs font-bold uppercase tracking-wider text-emerald-600" data-id="element-1212">
                Het juiste antwoord
              </span>
            </div>
            <div className="font-bold text-emerald-900 text-lg pl-7" data-id="element-1213">
              <LatexRenderer content={correctAnswer} data-id="element-1214" />
            </div>
          </div>
        </motion.div>}
    </div>;
}